__turbopack_context__.v({
  "bookmarkIcon": "bookmark-module__rTbIrW__bookmarkIcon",
  "card": "bookmark-module__rTbIrW__card",
  "card-grid": "bookmark-module__rTbIrW__card-grid",
});
